import React, { memo, forwardRef } from "react";
const SvgNumberfive = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11.18 21.96a1.645 1.645 0 01-.3-.48c-.053-.147-.08-.3-.08-.46 0-.307.107-.567.32-.78.227-.213.493-.32.8-.32.16 0 .32.04.48.12.173.067.36.233.56.5.267.347.587.62.96.82.387.187.82.28 1.3.28.36 0 .7-.06 1.02-.18.32-.12.6-.293.84-.52.24-.227.427-.507.56-.84.147-.347.22-.733.22-1.16 0-.547-.093-1-.28-1.36a2.332 2.332 0 00-.74-.86 2.453 2.453 0 00-1-.46 4.679 4.679 0 00-1.14-.14c-.507 0-1.073.073-1.7.22-.133.027-.24.053-.32.08a1.726 1.726 0 01-.54 0 .903.903 0 01-.32-.16 1.2 1.2 0 01-.26-.34c-.067-.147-.1-.34-.1-.58l.14-4.82c.013-.907.473-1.36 1.38-1.36h5.7c.253 0 .46.04.62.12.16.08.28.18.36.3.093.107.153.22.18.34.027.12.04.227.04.32s-.013.2-.04.32a.912.912 0 01-.18.36c-.08.107-.2.2-.36.28-.16.08-.367.12-.62.12h-4.76l-.14 3.06a4.12 4.12 0 01.8-.14c.32-.027.607-.04.86-.04.693 0 1.333.1 1.92.3.6.2 1.12.493 1.56.88.44.373.78.84 1.02 1.4.253.547.38 1.18.38 1.9 0 .787-.14 1.493-.42 2.12a4.532 4.532 0 01-1.1 1.56 4.842 4.842 0 01-1.64.98 5.836 5.836 0 01-2 .34c-.867 0-1.633-.147-2.3-.44a4.706 4.706 0 01-1.68-1.28z"
      />
    </svg>
  );
});
SvgNumberfive.displayName = "SvgNumberfive";
const MemoForwardRef = memo(SvgNumberfive);
export default MemoForwardRef;
